import { Layers, RefreshCcw, Scissors, Shuffle } from "lucide-react";

export function CraftIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return <Scissors size={size} className={className} aria-hidden />;
}

export function IdeaIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return <Layers size={size} className={className} aria-hidden />;
}

export function SleeveIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4 6l4-3h8l4 3v2l-2 1v9a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V9L4 8V6z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <line x1="4" y1="6" x2="8" y2="9" stroke="currentColor" strokeWidth="2" />
      <line
        x1="20"
        y1="6"
        x2="16"
        y2="9"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}

export function NecklineIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.9 18.8c-0.05-0.01-4.9-1.3-6.8-2.7c-1.5-1.1-1.0-4.5-0.8-5.5c0.3-0.4 0.5-0.7 0.6-0.8c0.6-1.0 1.6-4.6 1.6-4.7c0.03-0.1-0.03-0.2-0.1-0.3c-0.1-0.03-0.2 0.03-0.3 0.1c-0.01 0.03-0.6 2.0-1.1 3.4h-1.9c-0.1 0-0.2 0.1-0.2 0.2c0 0.1 0.1 0.2 0.2 0.2h1.7c-0.1 0.3-0.3 0.6-0.4 0.8c-0.7 1.2-2.4 3.2-4.5 3.4c-2.1-0.2-3.8-2.2-4.5-3.4c-0.1-0.2-0.2-0.4-0.3-0.7h3.6c0.1 0 0.2-0.1 0.2-0.2c0-0.1-0.1-0.2-0.2-0.2h-3.8c-0.1-0.3-0.2-0.5-0.3-0.8h2.1c0.1 0 0.2-0.1 0.2-0.2c0-0.1-0.1-0.2-0.2-0.2h-2.2c-0.4-1.2-0.7-2.3-0.7-2.3c-0.03-0.1-0.1-0.2-0.3-0.1c-0.1 0.03-0.2 0.1-0.1 0.3c0.04 0.2 1.1 3.7 1.6 4.7c0.1 0.1 0.2 0.4 0.5 0.8c0.2 0.8 0.8 4.4-0.8 5.5C4.9 17.5 0.2 19.1 0.2 19.1c-0.1 0.03-0.2 0.1-0.1 0.3c0.02 0.1 0.1 0.2 0.2 0.2c0.02 0 0.03 0 0.05 0c0.2-0.05 5.0-1.3 6.9-2.7c1.5-1.1 1.2-4.0 1.0-5.3c0.2 0.2 0.5 0.5 0.7 0.7c1.0 0.9 2.1 1.4 3.1 1.5c0.005 0 0.01 0.005 0.01 0.005c0.005 0 0.01-0.001 0.01-0.005c1.1-0.1 2.1-0.6 3.1-1.5c0.2-0.2 0.5-0.5 0.7-0.7c-0.2 1.3-0.5 4.1 1.0 5.2c1.1 0.8 2.9 1.5 4.5 2.0h-3.3c-0.1 0-0.2 0.1-0.2 0.2c0 0.1 0.1 0.2 0.2 0.2h4.6c0.7 0.2 1.1 0.3 1.2 0.3c0.02 0 0.03 0 0.05 0c0.1 0 0.2-0.1 0.2-0.2C24.1 18.9 24.0 18.8 23.9 18.8z"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9 12.5c-0.1-0.01-0.2 0.07-0.2 0.2c-0.1 1.1-0.1 2.6 0.5 3.7c0.04 0.06 0.1 0.1 0.2 0.1c0.04 0 0.1-0.01 0.1-0.03c0.1-0.06 0.1-0.2 0.07-0.3c-0.6-0.9-0.6-2.4-0.5-3.4C15.0 12.6 15.0 12.5 14.9 12.5z"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.7 16.4c0.03 0.02 0.07 0.03 0.1 0.03c0.07 0 0.1-0.04 0.2-0.1c0.6-1.0 0.6-2.6 0.5-3.7c-0.01-0.1-0.1-0.2-0.2-0.2c-0.1 0.01-0.2 0.1-0.2 0.2c-0.1 1.0-0.1 2.5-0.5 3.4C8.6 16.2 8.6 16.3 8.7 16.4z"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17.6c-0.3 0.04-3.2 0.4-3.9 1.0c-0.08 0.08-0.09 0.2-0.01 0.3c0.04 0.04 0.1 0.07 0.1 0.07c0.05 0 0.1-0.02 0.1-0.05c0.4-0.4 2.4-0.8 3.6-0.9c0.1-0.01 0.2 0.1 0.2 0.2C18.5 17.5 18.3 17.6 17.5 17.6z"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.7 17.6c-0.1-0.01-0.2 0.07-0.2 0.2c-0.01 0.1 0.07 0.2 0.2 0.2c0.9 0.1 3.2 0.5 3.6 0.9c0.04 0.04 0.1 0.05 0.1 0.05c0.05 0 0.1-0.03 0.1-0.07c0.08-0.08 0.07-0.2-0.01-0.3C9.9 18.0 7.0 17.6 6.7 17.6z"
        stroke="currentColor"
        strokeWidth="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SilhouetteIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11 18H13M7 6.5V7.39445C7 7.7893 7.11688 8.17531 7.3359 8.50385L9.20039 11.3006C9.67791 12.0169 9.64351 12.9583 9.11499 13.6379L6.9213 16.4583C6.64824 16.8094 6.5 17.2415 6.5 17.6862V18.7929C6.5 19.2456 6.67986 19.6799 7 20C7.32014 20.3201 7.75435 20.5 8.20711 20.5H15.7929C16.2456 20.5 16.6799 20.3201 17 20C17.3201 19.6799 17.5 19.2456 17.5 18.7929V17.6862C17.5 17.2415 17.3518 16.8094 17.0787 16.4583L14.885 13.6379C14.3565 12.9583 14.3221 12.0169 14.7996 11.3006L16.6641 8.50385C16.8831 8.17531 17 7.7893 17 7.39445V6.5C17 5.39543 16.1046 4.5 15 4.5H9C7.89543 4.5 7 5.39543 7 6.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ResetIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return <RefreshCcw size={size} className={className} aria-hidden />;
}

export function RandomizeIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return <Shuffle size={size} className={className} aria-hidden />;
}

export function TikTokIcon({
  className = "",
  size = 24,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </svg>
  );
}
